import axios from "axios";  
import { BASE_URL } from "../../assets/constant";
import { createHeadersAdmin } from "../../utils/Utils";

//! Admin Login
//  Admin Login
export const adminLoginAPI = async (data) => {  
  return await axios.post(`${BASE_URL}auth/login`, data);
};
export const adminLogoutAPI = async (data) => {
  const headers = createHeadersAdmin()
  return await axios.post(`${BASE_URL}auth/logout`, data,headers);
};
export const sideBarAPI = async (data) => {
  const headers = createHeadersAdmin()
  return await axios.post(`${BASE_URL}sidebar`, data,headers);
};

export const changeAdminPasswordAPI = async (data) => {
  const headers = createHeadersAdmin();
  return await axios.put(`${BASE_URL}admin/change-password`, data, headers);
};